import React, { useRef, useState } from 'react'

const ShareModal = ({ sharing, handleShare, name, cancel }) => {
  const onShareClick = () => {
    handleShare()
  }

  return <div id="share-modal" className={`modal ${ sharing ? 'is-active' : ''}`}>
          <div className="modal-background"></div>
          <div className="modal-card">
            <header className="modal-card-head">
              <h1 className="modal-card-title">
                SHARE THIS LIST</h1>
              <button onClick={cancel} className="btn-icon-only icon-lg btn-close" aria-label="close">
                <span className="icon icon-close-large"></span><span className="sr-only">Close this
                  dialog</span>
              </button>
            </header>
            <section className="modal-card-body min-height-large-container">
              <p>When you share this list, a public link to the list will be created. You can copy this link and send it to anyone you choose. They will be able to view, but not edit, the list.</p>
              <p>In the future, you can stop sharing the list, which will delete the public link, and prevent others from accessing it.</p>
              <fieldset>
                <legend>List Name:</legend>
                <ul>
                  <li><strong>{name}</strong></li>
                </ul>
              </fieldset>
            </section>
            <footer className="modal-card-foot">
              <div className="is-flex ml-auto">
                <button className="button" onClick={cancel} >Cancel</button>
                <button className="btn-solid" onClick={onShareClick}>Share</button>
              </div>
            </footer>
          </div>
        </div>
}

export default ShareModal